// libs
import { styled } from '@nykaa/ui-components';

// components
import BaseOverlaySheet from 'shared/components/OverlaySheet';
import BaseImage from 'shared/components/ImageV2';

// constants
import { resetButton } from 'shared/styles/mixin';

export const Container = styled(BaseOverlaySheet)`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.overlayBg};
  top: initial;
  animation-duration: 0.3s;
  border-radius: ${({ theme }) => `${theme.borders.radius40} ${theme.borders.radius40} 0 0`};
  padding: ${({ theme }) =>
    `${theme.spacing.spacing200} ${theme.spacing.spacing160} ${theme.spacing.spacing100} ${theme.spacing.spacing160}`};
  display: flex;
  flex-flow: column;
  align-items: center;

  &:before {
    content: '';
    position: absolute;
    top: 12px;
    height: 4px;
    left: 50%;
    transform: translateX(-50%);
    width: 32px;
    border-radius: ${({ theme }) => theme.borders.radius10};
    background: #cdd3d8;
  }
`;

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 98px;
  height: 98px;
  background-color: ${({ theme }) => theme.colors.responsibleTagBg};
  border-radius: ${({ theme }) => theme.borders.radiusFull};
`;

export const Image = styled(BaseImage)`
  width: 56px;
  height: 56px;
`;

export const Title = styled.p`
  margin: 0;
  margin-top: ${({ theme }) => theme.spacing.spacing80};
  ${({ theme }) => theme.typography.titleMedium};
`;

export const Content = styled.p`
  margin: 0;
  margin-top: ${({ theme }) => theme.spacing.spacing60};
  text-align: center;
  ${({ theme }) => theme.typography.bodyMedium};
  color: ${({ theme }) => theme.colors.textSecondary};
`;

export const SecondaryButton = styled.button`
  ${resetButton}
  border: solid 1px ${({ theme }) => theme.colors.textOutline};
  ${({ theme }) => theme.typography.buttonLarge};
  letter-spacing: 0.5px;
  color: ${({ theme }) => theme.colors.textPrimary};
  height: 48px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 ${({ theme }) => theme.spacing.spacing80};
  cursor: pointer;
  margin-top: ${({ theme }) => theme.spacing.spacing100};
  border-radius: ${({ theme }) => theme.borders.mwebButtonBorderRadius};
`;
